<template>

  <div class="">

    <div v-if="$store.state.fetchcomplete" class="shadow-md m-4 p-2 pt-10 rounded-lg sm:border-l-4 border-blue-100 bg-blue-100" ref="height">


      <div class="flex items-center justify-center cursor-pointer mb-8">

        <button @click="timewarp()" v-bind:class="{ 'bg-orange-300': present == true }" class="button-portfolio bg-white text-gray-800 font-bold rounded rounded-r-none py-2 px-6 inline-flex items-center">
          <span class="mr-2">Heute</span>
        </button>

        <button @click="timewarp()" v-bind:class="{ 'bg-orange-300': present !== true }" class="bg-white text-gray-800 font-bold rounded  rounded-l-none py-2 px-6 inline-flex items-center">
          <span class="mr-2">Früher</span>
        </button>

      </div>

      <div class="mb-6 w-full mx-auto">
        <img class="rounded-sm" v-if="present" :src="markerInfos.bild.sizes.large" alt="">
        <img class="rounded-sm" v-else  :src="markerInfos.bild_history.sizes.large" alt="">
      </div>

      <div v-if="present" class="mx-6 text-left" v-html="markerInfos.beschreibung"> </div>
      <div v-else class="mx-6 text-left" v-html="markerInfos.beschreibung_history"> </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {

  },
  name: 'WandernInfo',
  props: {

  },
  data() {
    return {

      present: true,

    }
  },
  methods: {

    timewarp(){

      this.present = !this.present;
      this.$store.commit('updatetime');

    }


  },
  mounted: function(){

  },

  computed: {

    markerInfos () {

      if (this.$store.state.fetchcomplete){

        var result = this.$store.state.markers.filter(obj => {
          return obj.id === this.$store.state.currentMarker;
        })

      }

      return result[0];

    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#map{
  height: 100%;
  width: 50%;

}

button{
  // display: block;

}

</style>
